import { render, staticRenderFns } from "./ModifyEventDetails.vue?vue&type=template&id=9d5468a8&scoped=true&"
import script from "./ModifyEventDetails.vue?vue&type=script&lang=ts&"
export * from "./ModifyEventDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ModifyEventDetails.vue?vue&type=style&index=0&id=9d5468a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5468a8",
  null
  
)

export default component.exports